import * as _ from "lodash";
import { IBusinessObject, IBusinessObjectChanges, IBusinessObjectChangesOptions } from "../PA.Core.IF.BO";
import { ESRecord } from "../lib/ESRecord";
import { eRecordChangeType, ESRecordChanges, IChangedValue, IRecordChange } from "../lib/ESRecordChanges";

export function DefaultChanges(
    BO: IBusinessObject,
    BOMainRecord: ESRecord,
    options?: IBusinessObjectChangesOptions,
): IBusinessObjectChanges {
    //--
    const returnValue: IBusinessObjectChanges = {
        bHasChanges: false,
        bMainRecordExists: BOMainRecord._rowExists,
        Changes: [],
    };

    const opts = options || {};

    const changes = ESRecordChanges.findChanges(BOMainRecord, options);

    if (_.isEmpty(changes)) return returnValue;

    /** Format an unknown value type based on its type and the column name*/
    const formatValue = (value: unknown, colName: string): string => {
        switch (typeof value) {
            case "number":
                break;
            case "boolean":
                return value ? "True" : "False";
            case "string":
                if (colName.includes("_IND")) {
                    return value === "1" ? "True" : "False";
                }
                return value;
            default:
                return value as string;
        }

        const rounded = Math.round(value * 100) / 100;
        switch (true) {
            case colName.includes("QTY"):
                return Math.round(value).toFixed(0);
            case colName.includes("PCNT"):
            case colName.includes("PCT"):
                return `${(rounded * 100).toFixed(2)}%`;
            case colName.includes("AMT"):
            case colName.includes("PRICE"):
                return `$${rounded.toFixed(2)}`;
            default:
                return rounded.toFixed(2);
        }
    };

    const createMessage = (fldInfo: IChangedValue): string => {
        return `${fldInfo.column}: was ${formatValue(fldInfo.previous, fldInfo.column)}, is now ${formatValue(fldInfo.value, fldInfo.column)}`;
    };

    returnValue.bHasChanges = true;
    returnValue.Changes = _.map(changes, (aChange) => {
        let msg: string;
        const rowid = `${aChange.mapperUI || aChange.mapper} (${aChange.lk || aChange.id})`;

        switch (aChange.type) {
            case eRecordChangeType.New:
                msg = `New record ${rowid}`;
                break;

            case eRecordChangeType.Delete:
                msg = `Deleted record ${rowid}`;
                break;

            case eRecordChangeType.Update: {
                msg = `Updated record ${rowid}, has changes:\n${aChange.changes.map((item) => createMessage(item)).join("\n\t")}`;
                break;
            }
        }

        return {
            Message: msg || "Unknown Type",
            RecordChange: aChange,
        };
    });

    return returnValue;
}
